var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c("div", { staticClass: "media-dialog" }, [
        _c("div", { staticClass: "media-dialog__header" }, [
          _c(
            "button",
            { staticClass: "border-0 bg-transparent", on: { click: _vm.hide } },
            [_c("i", { staticClass: "fas fa-2x fa-times" })]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "media-dialog__body" },
          [
            !_vm.isInitialized ? _c("loading") : _vm._e(),
            _vm._v(" "),
            _vm.isInitialized
              ? _c(
                  "contact-form",
                  _vm._b(
                    { on: { stored: _vm.onStored } },
                    "contact-form",
                    _vm.formData,
                    false
                  )
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }